// old should be removed after iframe chat bot is launched
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { pushEvent, setActiveChat } from 'state/analytics/analytics-slice';

const { VITE_CHATBOT_URL, VITE_STAGE } = import.meta.env;

export type AnalyticsEvent = {
  category: string;
  action: string;
  label: string;
  message?: string;
  journey?: string;
  status?: string;
} | null;

type ChatEventData = {
  text?: string;
  sessionId?: string;
  name?: string;
};

type ChatEventMessage = {
  eventName: string;
  app: string;
  category: string;
  eventData: ChatEventData;
};

export const useChatEvents = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleChatEvent = (event: MessageEvent<ChatEventMessage>) => {
      const {
        origin,
        data: { eventName, app, category, eventData }
      } = event;
      /* istanbul ignore next -- @preserve */
      const isChatBotEvent =
        (origin === VITE_CHATBOT_URL && app === 'hfb') || VITE_STAGE === 'test';
      /* istanbul ignore next -- @preserve */
      const shouldTrackEvent = isChatBotEvent && category === 'tracking';

      /* istanbul ignore next -- @preserve */
      if (!isChatBotEvent) {
        return;
      }

      if (eventName === 'visible') {
        dispatch(
          setActiveChat({
            lexBot: eventData,
            salesForce: !eventData
          })
        );
        return;
      }

      /* istanbul ignore next -- @preserve */
      if (!shouldTrackEvent) {
        return;
      }

      let latestEvent: AnalyticsEvent = null;

      switch (eventName) {
        case 'onOptionSelect':
          latestEvent = {
            category: 'in_hours_chat',
            action: 'option_selected',
            label: 'web_chat',
            message: eventData?.text
          };
          break;
        case 'chatRequestSuccess':
          latestEvent = {
            category: 'in_hours_chat',
            action: 'chat_request_success',
            label: 'web_chat'
          };
          break;
        case 'openChat':
          latestEvent = {
            category: 'out_of_hours_chat',
            action: 'lex_chat_opened',
            label: 'web_chat',
            journey: eventData?.sessionId
          };
          break;
        case 'closeChat':
          latestEvent = {
            category: 'out_of_hours_chat',
            action: 'lex_chat_closed',
            label: 'web_chat',
            journey: eventData?.sessionId
          };
          break;
        case 'intent':
          latestEvent = {
            category: 'out_of_hours_chat',
            action: 'intent',
            label: 'web_chat',
            journey: eventData?.sessionId,
            message: eventData?.name
          };
          break;
        default:
          return;
      }

      latestEvent && dispatch(pushEvent(latestEvent));
    };

    const cleanup = () => {
      window.removeEventListener('message', handleChatEvent);
    };

    cleanup();
    window.addEventListener('message', handleChatEvent);

    return cleanup;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
